import { can } from "./permissions";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children, module, action = "view" }) => {
  return can(module, action) ? children : <Navigate to="/" replace />;
};
